import FaqAccordion from "./accoedion";

const Faq = () => {
  return (
    <div>
      {/* <!-- FAQ --> */}
      <section className="relative py-24 dark:bg-jacarta-800">
        <div className="container">
          <div className="justify-between lg:flex lg:space-x-20">
            <div className="lg:w-[45%]">
              <h2 className="mb-6 font-display text-3xl font-medium text-jacarta-700 dark:text-white">
                Frequently Asked Questions
              </h2>
              <p className="mb-12 text-lg dark:text-jacarta-300">
                {`Discover answers to common questions about GMJA Arc-Hive, a
                platform dedicated to preserving Ethiopia's architectural
                heritage through digital innovation.`}
              </p>

              <FaqAccordion />

              <p className="text-lg text-jacarta-700 dark:text-jacarta-100">
                Have more questions?{" "}
                <a href="#" className="text-green lowercase">
                  gmja.archive@gmail.com
                </a>
              </p>
            </div>
            <div className="lg:w-[55%]">
              <div className="mt-12 md:flex animate-fly  md:space-x-8 lg:justify-end">
                <img
                  src="/images/hero/hero_consultant_main.jpg"
                  className="mb-8 max-w-xs inline-block rounded-2.5xl"
                  alt="GMJA FAQ"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- end faq --> */}
    </div>
  );
};

export default Faq;
